import React from 'react';
import PropTypes from 'prop-types';
import ForgotPasswordForm from '../components/ForgotPasswordForm'
import {connect} from 'react-redux';
import {clearError, forgotPassworddRequest} from '../actions/auth';

class ForgotPassword extends React.Component {
  componentDidMount() {
    this.props.dispatch(clearError())
  }

  handleSubmit = (e) => {
    e.preventDefault();
    const form = this.form
    const {location} = this.props
    form.validateFields((err, values) => {
      if (err) {
        return;
      }
      const {email} = values
      this.props.dispatch(clearError())
      this.props.dispatch(forgotPassworddRequest(email))
    });
  };

  saveFormRef = (form) => {
    this.form = form;
  };

  render() {
    const {fetching, error} = this.props
    return <ForgotPasswordForm ref={this.saveFormRef} error={error} fetching={fetching} onSubmit={this.handleSubmit}/>
  }
}

ForgotPassword.propTypes = {
  dispatch: PropTypes.func,
  fetching: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {error: state.auth.error, fetching: state.auth.fetching}
}

export default connect(mapStateToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/pages/ForgotPassword.js